import { getlocalStorageLogin } from "common/components/apiConfig";
import { useEffect, useState } from "react";
import RouterCustom from "./routerCustom";
import StepOne from "./stepOne";
import StepThree from "./stepThree";
import StepTwo from "./stepTwo";

const PassWordModule = () => {
  const [indexChild, setIndexChild] = useState(0);
  const [national_id, setNational_id] = useState("");
  const [loading, setLoading] = useState(false);
  const adminObj = getlocalStorageLogin();

  const auth = adminObj;
  let user = auth?.user;
  let title = "تغییر رمز عبور";

  useEffect(() => {
    if (user?.member_national_id) {
      let id = user?.member_national_id;
      setNational_id(id);
    }
  }, [user?.member_national_id]);
  return (
    <>
      <div className="mt-5">
        <RouterCustom indexChild={indexChild}>
          <StepOne
            title={title}
            setLoading={setLoading}
            loading={loading}
            setIndexChild={setIndexChild}
            national_id={national_id}
          />
          <StepTwo
            title={title}
            setLoading={setLoading}
            loading={loading}
            setIndexChild={setIndexChild}
            national_id={national_id}
          />
          <StepThree
            title={title}
            setLoading={setLoading}
            loading={loading}
            setIndexChild={setIndexChild}
            national_id={national_id}
          />
        </RouterCustom>
      </div>
    </>
  );
};

export default PassWordModule;
